<template>
  <header class="light-dark-int">
    <v-layout>
      <v-flex sm6>
        <router-link class="img-container linkhome" id="linkhome" to="/" aria-label="ir al inicio">
          <div>
            <img class="ima-header hidden-xs-only" src="../../assets/logos-icons/davi-header.png" alt="">
          </div>
        </router-link>
      </v-flex>
      <v-flex sm6>
        <section>
          <p class="text-xs-right user-info" aria-label="informacion de usuario">
            <span class="nombre" aria-label="Nombre del usuario">
              <strong>Andres Martínez</strong>
            </span><br>
            <span class="curso" aria-label="Nombre del curso">Entidades Financieras</span>
            <span v-if="screenTrack[0] >= 1" class="pantallas" aria-label="Avance del curso"> / Pantalla
              <strong>{{screenTrack[0]}}</strong> de
              <strong>{{screenTrack[1]}}</strong>
            </span>
          </p>
        </section>
      </v-flex>
    </v-layout>
  </header>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    screenTrack() {
      return this.$store.state.screens;
    }
  },
  watch: {
    $route() {
      document.getElementById("linkhome").focus();
    }
  }
};
</script>

<style lang="scss" scope>
@import "../../sass/helpers/variables.scss";

header {
  width: 100%;
  min-height: 60px;
  font-size: 1rem;
  line-height: 1.5rem;
  box-shadow: 4px 0px 15px black;
  text-align: right;
  margin-bottom: 20px;
  padding: 10px;
  font-style: italic;
  position: relative;
  z-index: 10 !important;
  .nombre {
    font-size: 1.1em;
    color: $primary-red;
  }
  p {
    margin-bottom: 0;
  }
}

.user-info {
  position: relative;
  z-index: 6;
  margin-right: 20px;
}

.img-container {
  position: absolute;
  top: 0;
  left: 0;
  &:focus {
    outline: none;
  }

  img {
    position: relative;
    z-index: 6;
  }
}
</style>





// WEBPACK FOOTER //
// Header.vue?0d79a99b